import { render, staticRenderFns } from "./ot-address-field.vue?vue&type=template&id=ae926850&scoped=true&"
import script from "./ot-address-field.vue?vue&type=script&lang=ts&"
export * from "./ot-address-field.vue?vue&type=script&lang=ts&"
import style0 from "./ot-address-field.vue?vue&type=style&index=0&id=ae926850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae926850",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VForm,VImg})
